import { ORGANIZATION_ID, WEBSITE_ID } from "./constants"

export { ORGANIZATION_ID, WEBSITE_ID }

/** 站内越南语路由使用 vn，结构化数据须使用 BCP-47 语言码 vi。 */
export function getJsonLdLanguage(locale: string): string {
  return locale === "vn" ? "vi" : locale
}

type Json = string | number | boolean | null | Json[] | { [key: string]: Json }
export type JsonLdNode = { [key: string]: Json }

export interface JsonLdGraph {
  "@context": "https://schema.org"
  "@graph": JsonLdNode[]
}

/**
 * 组装一个 @graph 文档。渲染时必须使用 <JsonLdScript>（内部已做 XSS 转义），
 * 不要直接 JSON.stringify 到 <script> 中。
 */
export function buildJsonLdGraph(nodes: JsonLdNode[]): JsonLdGraph {
  return {
    "@context": "https://schema.org",
    "@graph": nodes,
  }
}
